import { LoaderContainer } from "./loadingData.styles";
import { BounceLoader } from "react-spinners";

const LoadingData = ({ ...props }: React.AllHTMLAttributes<HTMLDivElement>) => {
  return (
    <LoaderContainer {...props}>
      <BounceLoader color="#000" size={72} />
    </LoaderContainer>
  );
};
export default LoadingData;
